import { Link } from 'react-router-dom'
import type { Technology } from '../../data/technologies'
import { TechnologyStatus } from './TechnologyStatus'

export function TechnologyCard({ technology, compact = false }: { technology: Technology; compact?: boolean }) {
  return (
    <Link className={`tech-card${compact ? ' tech-card--compact' : ''}`} to={technology.route}>
      <div className="tech-card__meta"><span>{technology.id.replace('tech-', 'Tech / ')}</span><TechnologyStatus status={technology.status} /></div>
      <div className="tech-card__visual"><img src={technology.image} alt={technology.imageAlt} loading="lazy" /></div>
      <div className="tech-card__copy"><span>{technology.category}</span><h3>{technology.name}</h3><p>{technology.description}</p></div>
      <div className="tech-card__footer"><div>{technology.tags.map((tag) => <span key={tag}>{tag}</span>)}</div><strong>Explore <i>↗</i></strong></div>
    </Link>
  )
}
